var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.75293C13.1989 2.75293 13.3897 2.83195 13.5303 2.9726C13.671 3.11325 13.75 3.30402 13.75 3.50293C13.75 3.70184 13.671 3.89261 13.5303 4.03326C13.3897 4.17391 13.1989 4.25293 13 4.25293H12.25L12.2477 4.30618L11.548 14.1094C11.5211 14.4879 11.3517 14.842 11.0741 15.1006C10.7965 15.3592 10.4311 15.5029 10.0518 15.5029H3.9475C3.5681 15.5029 3.2028 15.3592 2.92516 15.1006C2.64753 14.842 2.47819 14.4879 2.45125 14.1094L1.7515 4.30693C1.75036 4.28895 1.74986 4.27094 1.75 4.25293H1C0.801088 4.25293 0.610322 4.17391 0.46967 4.03326C0.329018 3.89261 0.25 3.70184 0.25 3.50293C0.25 3.30402 0.329018 3.11325 0.46967 2.9726C0.610322 2.83195 0.801088 2.75293 1 2.75293H13ZM10.7477 4.25293H3.25225L3.94825 14.0029H10.0518L10.7477 4.25293ZM8.5 0.50293C8.69891 0.50293 8.88968 0.581947 9.03033 0.7226C9.17098 0.863252 9.25 1.05402 9.25 1.25293C9.25 1.45184 9.17098 1.64261 9.03033 1.78326C8.88968 1.92391 8.69891 2.00293 8.5 2.00293H5.5C5.30109 2.00293 5.11032 1.92391 4.96967 1.78326C4.82902 1.64261 4.75 1.45184 4.75 1.25293C4.75 1.05402 4.82902 0.863252 4.96967 0.7226C5.11032 0.581947 5.30109 0.50293 5.5 0.50293H8.5Z",
    fill: "#51CDA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b4e5676a4eec91a46589d3d448fdcb37.svg";
export { ForwardRef as ReactComponent };